import styled from 'styled-components';
import {tokens} from "../../theme";

export const LanguageSwitcherContainer = styled.button`
    position: relative;
    display: flex;
    align-items: center;
    gap: 8px;
    cursor: pointer;
    padding: 8px 12px;
    border-radius: 20px;
    transition: all 0.2s ease;
    background: transparent;
    border: none;
    font-family: ${({ theme }) => theme.typography.fontFamily};

    &:hover {
        background-color: ${({ theme }) => theme.palette.action.hover};
    }

    svg {
        height: 20px;
        width: 20px;
        color: ${({ theme }) => theme.palette.text.primary};
        opacity: 0.8;
        transition: opacity 0.2s ease;
    }

    &:hover svg {
        opacity: 1;
    }
`;

export const LanguageLabel = styled.span`
    font-weight: ${({ theme }) => theme.typography.button};
    color: ${({ theme }) => theme.palette.text.primary};
    user-select: none;
    opacity: 0.8;
    transition: opacity 0.2s ease;

    ${LanguageSwitcherContainer}:hover & {
        opacity: 1;
    }
`;

export const LanguageDropdown = styled.div<{ $isOpen: boolean }>`
    position: absolute;
    top: calc(100% + 8px);
    right: 0;
    background: ${({ theme }) => theme.palette.background.paper};
    
    border: 1px solid ${({ theme }) => theme.palette.dividers.subtle};
    border-radius: 16px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    min-width: 150px;
    overflow: hidden;
    z-index: 1000;
    
    opacity: ${props => props.$isOpen ? '1' : '0'};
    visibility: ${props => props.$isOpen ? 'visible' : 'hidden'};
    transform: ${props => props.$isOpen ? 'translateY(0)' : 'translateY(-10px)'};
    transition: all 0.3s ease;
    
    font-family: ${({ theme }) => theme.typography.fontFamily};
`;

export const LanguageOption = styled.button<{ $isActive: boolean }>`
    width: 100%;
    padding: 12px 16px;
    cursor: pointer;
    text-align: left;
    transition: all 0.2s ease;
    
    color: ${({$isActive, theme}) => $isActive ? theme.palette.text.primary :  theme.palette.secondary.main};
    background: ${({$isActive, theme}) => $isActive ? theme.palette.action.hover : 'transparent'};
    
    border: none;
    border-radius: ${({ theme }) => theme.shape.borderRadius};
    
    font-size: ${({ theme }) => theme.typography.body2.fontSize};
    font-weight: ${props => props.$isActive ? tokens.fontWeight.semibold : tokens.fontWeight.normal};
    font-family: ${({ theme }) => theme.typography.fontFamily};

    &:hover {
        background-color: ${({ theme }) => theme.palette.action.hover};
    }
`;
